import { useFormatDate, useT } from "src/internationalization";
import { Alert } from "src/types/alert";

import { PrintableProperties } from "./PrintableWidgetContainer";

export function PrintableChronologyWidget({ alert }: { alert: Alert }) {
  const t = useT();
  const formatDate = useFormatDate();
  const events = [
    {
      label: t("page.alert.tab.synthesis.widget.chronology.date.requested"),
      date: alert.requestedDate,
    },
    {
      label: t("page.alert.tab.synthesis.widget.chronology.date.imported"),
      date: alert.caseImportedDate,
    },
    {
      label: t("page.alert.tab.synthesis.widget.chronology.date.caseScored"),
      date: alert.caseScoringDate,
    },
    {
      label: t("page.alert.tab.synthesis.widget.chronology.date.generated"),
      date: alert.creationDate,
    },
    ...(alert.isAlertValidated
      ? [
          {
            label: t("page.alert.tab.synthesis.widget.chronology.date.validated"),
            date: alert.validationDate,
          },
        ]
      : []),
    ...(alert.isAlertCanceled
      ? [
          {
            label: t("page.alert.tab.synthesis.widget.chronology.date.canceled"),
            date: alert.cancelledDate,
          },
        ]
      : []),
  ];
  return (
    <PrintableProperties
      properties={events.map((event) => ({
        label: event.label,
        value: event.date
          ? formatDate(event.date, { dateStyle: "medium", timeStyle: "short" })
          : "—",
      }))}
    />
  );
}
